import React from 'react';
import { ITaggingParams } from '../tagging/types';

export enum Types {
  ADD_TOAST = 'toast/ADD_TOAST',
  REMOVE_TOAST = 'toast/REMOVE_TOAST'
}

export interface IToastState {
  toasts: IToast[];
}

export interface IToast {
  id?: string;
  type: EToastTypes;
  message: string | React.ReactNode;
  labelActionOne?: string;
  labelActionTwo?: string;
  handleClickActionOne?: () => void;
  handleClickActionTwo?: () => void;
  durationInMS?: number;
  analyticsTag?: ITaggingParams;
  spaceToTop?: number;
}

export enum EToastTypes {
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
  INFO = 'info'
}
